import React from 'react';
import { withSessionSsr, getPublicToken } from "../../../../lib/sessionMiddleware";
import { getCanonicalPath } from "../../../../lib/canonical";
import { GrillaProductosSEO } from '../../../../components';

const TematicaPage = (props) => {

  const productosIniciales = props.pageProps.productosIniciales;
  const tematica = props.pageProps.tematica;

  const schema = [
    {
      "@context": "https://schema.org",
      "@type": "ItemList",
      "itemListElement": productosIniciales.map((p, i) => ({
        "@type": "ListItem",
        "position": i + 1,
        "url": `${process.env.NEXT_PUBLIC_URL_FRONTEND}/productos/${p.attributes.slug}`,
        "name": p.attributes.nombre,
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        { "@type": "ListItem", "position": 1, "name": "Inicio", "item": process.env.NEXT_PUBLIC_URL_FRONTEND },
        { "@type": "ListItem", "position": 2, "name": "Temáticas", "item": `${process.env.NEXT_PUBLIC_URL_FRONTEND}/tematicas` },
        { "@type": "ListItem", "position": 3, "name": tematica.nombre, "item": `${process.env.NEXT_PUBLIC_URL_FRONTEND}${props.pageProps.pathname}` },
      ],
    },
  ];

  return (
    <GrillaProductosSEO
      title={`Cotillón de ${tematica.nombre}`}
      description={`Todo el cotillón de ${tematica.nombre}: guirnaldas, bonetes, cajitas y más, listo para tu fiesta.`}
      h1={`Cotillón de ${tematica.nombre}`}
      path={props.pageProps.pathname}
      schema={schema}
      breadcrumb={[
        { label: 'Inicio', href: '/' },
        { label: 'Temáticas', href: '/tematicas' },
        { label: tematica.nombre },
      ]}
      productosIniciales={productosIniciales}
      totalPagesIniciales={props.pageProps.totalPagesIniciales}
      totalResultsIniciales={props.pageProps.totalResultsIniciales}
      filtroFijo={{ tematica: tematica.slug }}
    />
  );
};

export default TematicaPage;

export const getServerSideProps = withSessionSsr(
  async function getServerSideProps(ctx) {

    const { req, params } = ctx;
    const slug = params.slug;

    const publicToken = await getPublicToken(req);

    const fetchTematica = async () => {
      try {
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/tematicas/get-filtered`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
          body: JSON.stringify({ slug, pageSize: 1 }),
        });
        let data = await result.json();
        return data?.data?.[0] || null;
      } catch (err) {
        console.log("e", err);
        return null;
      }
    };

    const tematicaEntity = await fetchTematica();

    if (!tematicaEntity) {
      return { notFound: true };
    }

    const fetchProductosIniciales = async () => {
      try {
        const body = {
          liviano: true,
          page: 1,
          pageSize: 24,
          tematica: slug,
        };
        const result = await fetch(`${process.env.NEXT_PUBLIC_URL_FRONTEND}/api/productos/get-filtered`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-spiral-secret': process.env.SPIRAL_SECRET
          },
          body: JSON.stringify(body),
        });
        let data = await result.json();
        return {
          productos: data?.data || [],
          totalPages: Math.ceil((data?.meta?.pagination?.total || 0) / 24),
          totalResults: data?.meta?.pagination?.total || 0,
        };
      } catch (err) {
        console.log("e", err);
        return { productos: [], totalPages: 0, totalResults: 0 };
      }
    };

    const productosIniciales = await fetchProductosIniciales();

    return {
      props: {
        pathname: getCanonicalPath(req),
        tematica: { nombre: tematicaEntity.attributes.nombre, slug: tematicaEntity.attributes.slug },
        productosIniciales: productosIniciales.productos,
        totalPagesIniciales: productosIniciales.totalPages,
        totalResultsIniciales: productosIniciales.totalResults,
      },
    };

  },
);
